import { render, staticRenderFns } from "./TopComponent.vue?vue&type=template&id=4f084143"
import script from "./TopComponent.vue?vue&type=script&lang=js"
export * from "./TopComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports